import { Component, OnInit } from '@angular/core';
import {
  trigger,
  transition,
  state,
  animate,
  style,
  AnimationEvent,
  AUTO_STYLE,
} from '@angular/animations';
import { CommonContractService } from 'src/app/shared/services/common-contract.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { CreateTokenContractService } from '../../services/create-token-contract.service';
import { MytokenService } from '../../services/mytoken.service';
import { AnyTxtRecord } from 'dns';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
const DEFAULT_DURATION = 400;

@Component({
  selector: 'app-my-tokens',
  templateUrl: './my-tokens.component.html',
  styleUrls: ['./my-tokens.component.css'],
  animations: [
    trigger('collapse', [
      state('false', style({ height: AUTO_STYLE, display: AUTO_STYLE })),
      state('true', style({ height: '0', display: 'none', opacity: '0' })),
      transition('false => true', animate(DEFAULT_DURATION + 'ms ease-in-out')),
      transition(
        'true => false',
        animate(DEFAULT_DURATION + 'ms ease-out-out')
      ),
    ]),
  ],
})
export class MyTokensComponent implements OnInit {
  tokenAddress: any;
  accountObservable: any;
  environment: any;
  account: any;
  isValidToken: any;
  transactionUri: any;
  contractURI: any;
  tokenInfo: any;
  modalProcessing: boolean = false;
  functionProcessing: any = [];
  transactionHash: string = '';
  transactionRejected: boolean = false;
  searchButton: any = 'Search';
  searchProcessing: boolean = false;
  totalfunctionLength = 32;
  showViewTransaction: any = [];
  isMetamaskConnected:boolean=false

  public isMenuActive: number = 0;
  public isDeprecateCollapsed: boolean = false;
  public isApproveCollapsed: boolean = false;
  public evilUser: boolean = false;
  public isUnpauseCollapsed: boolean = false;
  public istransferFromCollapsed: boolean = false;
  public istransferCollapsed: boolean = false;
  public isPauseCollapsed: boolean = false;
  public isSetParamsCollapsed: boolean = false;
  public isIssueCollapsed: boolean = false;
  public isRedeemCollapsed: boolean = false;
  public isClearedUserCollapsed: boolean = false;
  public isNewOwnerCollapsed: boolean = false;
  public isBlackListedUserCollapsed: boolean = false;
  public isNameCollapsed: boolean = false;
  public isTotalSupplyCollapsed: boolean = false;
  public isDecimalsCollapsed: boolean = false;
  public isTotalSupplyyCollapsed: boolean = false;
  public isPausedCollapsed: boolean = false;
  public isBalanceOfCollapsed: boolean = false;
  public isOwnerCollapsed: boolean = false;
  public isSymbolCollapsed: boolean = false;
  public isAllowanceCollapsed: boolean = false;
  public isFromBxCollapsed: boolean = false;
  public isBurnCollapsed: boolean = false;
  public isBurnFromCollapsed: boolean = false;
  public isDecreaseAllowanceCollapsed: boolean = false;
  public isIncreaseAllowanceCollapsed: boolean = false;
  public isMintCollapsed: boolean = false;
  public isRenounceOwnershipCollapsed: boolean = false;
  public isTransferOwnershipCollapsed: boolean = false;
  public isDEFAULT_ADMIN_ROLECollapsed: boolean = false;
  public isLIQUIDITY_GENERATOR_ROLECollapsed: boolean = false;
  public ischarityAddressCollapsed: boolean = false;
  public ischarityFeeCollapsed: boolean = false;
  public ischarityFeeBalanceCollapsed: boolean = false;
  public ischarityFeeToSellCollapsed: boolean = false;
  public isenableFeeCollapsed: boolean = false;
  public isenableMaxTransactionAmountCollapsed: boolean = false;
  public isgetRoleAdminCollapsed: boolean = false;
  public ishasRoleCollapsed: boolean = false;
  public isExcludedFromDexFeeCollapsed: boolean = false;
  public isExcludedFromRewardCollapsed: boolean = false;
  public isliquidityFeeCollapsed: boolean = false;
  public isliquidityFeeToSellCollapsed: boolean = false;
  public ismarketingAddressCollapsed: boolean = false;
  public ismarketingFeeCollapsed: boolean = false;
  public ismarketingFeeBalanceCollapsed: boolean = false;
  public ismarketingFeeToSellCollapsed: boolean = false;
  public isreflectionFeeCollapsed: boolean = false;
  public issupportInterfaceCollapsed: boolean = false;
  public isswapAndLiquifyEnabledCollapsed: boolean = false;
  public istokenFromReflectionCollapsed: boolean = false;
  public istotalFeesCollapsed: boolean = false;
  public istransactionLimitCollapsed: boolean = false;
  public isuniswapV2PairCollapsed: boolean = false;
  public isuniswapV2RouterCollapsed: boolean = false;
  public isexcludeFromDexFeeCollapsed: boolean = false;
  public isexcludeFromDexRewardAddressCollapsed: boolean = false;
  public isgrantRoleCollapsed: boolean = false;
  public isincludeInDexFeeCollapsed: boolean = false;
  public isincludeInDexRewardCollapsed: boolean = false;
  public isrenounceRoleCollapsed: boolean = false;
  public isrevokeRoleCollapsed: boolean = false;
  public issetValuesCollapsed: boolean = false;
  public isupdateCharityAddressCollapsed: boolean = false;
  public isupdateCharityFeeCollapsed: boolean = false;
  public isupdateCharityFeeToSellCollapsed: boolean = false;
  public isupdateEnableFeeCollapsed: boolean = false;
  public isupdateEnableMaxTransactionAmountCollapsed: boolean = false;
  public isupdateLiquidityFeeCollapsed: boolean = false;
  public isupdateLiquidityFeeToSellCollapsed: boolean = false;
  public isupdateMarketingAddressCollapsed: boolean = false;
  public isupdateMarketingFeeCollapsed: boolean = false;
  public isupdateMarketingFeeToSellCollapsed: boolean = false;
  public isupdateReflectionFeeCollapsed: boolean = false;
  public isupdateSwapAndLiquifyEnabledCollapsed: boolean = false;
  public isupdateTransactionLimitCollapsed: boolean = false;
  public iswithdrawBEP20TokenCollapsed: boolean = false;
  public iswithdrawNativeFromContractCollapsed: boolean = false;
  /**
   * =======================================================
   *@dev temproary datas
   * =======================================================
   */
  allowanceOwner: any;
  allowanceSpendor: any;
  balanceOfAccount: any;
  approveSpender: any;
  approveAmount: any;
  burnAmount: any;
  burnFromAccount: any;
  accountBurnAmount: any;
  decreaseAllowanceSpender: any;
  decreaseAllowanceAmount: any;
  increaseAllowanceSpender: any;
  increaseAllowanceAmount: any;
  mintAmount: any;
  transferToAddress: any;
  transferToAmount: any;
  transferFromFromAddress: any;
  transferFromToAddress: any;
  transferFromAmount: any;
  transferOwnershipAddress: any;
  roleAdminByte: any;
  hasRoleByte: any;
  hasRoleAccount: any;
  isExcludedFromDexFeeAddress: any;
  isExcludedFromRewardAddress: any;
  isliquidityFeeBalanceCollapsed: any;
  supportInterfaceId: any;
  tokenFromReflectionAmount: any;
  excludeFromDexFeeAddress: any;
  excludeFromDexRewardAddress: any;
  grantRoleByte: any;
  grantRoleAddress: any;
  includeInDexFeeAddress: any;
  includeInDexRewardAddress: any;
  renounceRoleByte: any;
  renounceRoleAddress: any;
  revokeRoleByte: any;
  revokeRoleAddress: any;
  setValue_refectionFee: any;
  setValue_liquidityFee: any;
  setValue_liquidityFeeToSell: any;
  setValue_marketingFee: any;
  setValue_marketingFeeToSell: any;
  setValue_marketingAddress: any;
  setValue_charityFee: any;
  setValue_charityFeeToSell: any;
  setValue_charityAddress: any;
  setValue_trasactionLimit: any;
  updateCharityAddressAddress: any;
  updateCharityFeeAmount: any;
  updateCharityFeeToSellAmount: any;
  updateEnableFeeBool: any;
  updateEnableMaxTransactionAmountBool: any;
  updateLiquidityFeeAmount: any;
  updateLiquidityFeeToSellAmount: any;
  updateMarketingAddressAddress: any;
  updateMarketingFeeAmount: any;
  updateMarketingFeeToSellAmount: any;
  updateReflectionFeeAmount: any;
  updateSwapAndLiquifyEnabledBool: any;
  updateTransactionLimitAmount: any;
  withdrawBEP20TokenAddress: any;
  withdrawBEP20TokenAmount: any;
  withdrawNativeAddress: any;
  withdrawNativeAmount: any;
  functionError: any = [];
  functionErrorIndex: any;

  /**
   * =======================================================
   *@dev End of temp data
   * =======================================================
   */

  /**
   *
   * @param commonContractService
   * @param createTokenContractService
   * @param toastr
   * @param mytokenService
   */
  constructor(
    private commonContractService: CommonContractService,
    private createTokenContractService: CreateTokenContractService,
    private toastr: ToastrService,
    private mytokenService: MytokenService
  ) {}

  ngOnInit() {
    this.accountObservable =
      this.commonContractService.accountObservable.subscribe(
        async (res: string) => {
          if (res) {
            const transactionUri: any = environment.transactionURI;
            const addressUri: any = environment.contractURI;
            this.account = await res;
            this.transactionUri = transactionUri[this.account.chainId];
            this.contractURI = addressUri[this.account.chainId];
            for (let i = 0; i < this.totalfunctionLength; i++) {
              this.functionError.push('');
              this.functionProcessing.push('Write');
            }
          }
        }
      );

      this.accountObservable =
      this.commonContractService.isMetamaskConnectedObservable.subscribe(
        async (response: boolean) => {
          if (response) {
            this.isMetamaskConnected = response;
          }
        }
      );
  }
  // setActiveMenu(index: number) {
  //   this.isMenuActive = index;

  //   console.log('index', index);
  // }
  name() {
    this.isNameCollapsed = !this.isNameCollapsed;
  }
  burn() {
    this.isBurnCollapsed = !this.isBurnCollapsed;
  }
  totalSupply() {
    this.isTotalSupplyCollapsed = !this.isTotalSupplyCollapsed;
  }
  decimals() {
    this.isDecimalsCollapsed = !this.isDecimalsCollapsed;
  }
  paused() {
    this.isPausedCollapsed = !this.isPausedCollapsed;
  }
  balanceOf() {
    this.isBalanceOfCollapsed = !this.isBalanceOfCollapsed;
  }
  owner() {
    this.isOwnerCollapsed = !this.isOwnerCollapsed;
  }
  symbol() {
    this.isSymbolCollapsed = !this.isSymbolCollapsed;
  }
  allowance() {
    this.isAllowanceCollapsed = !this.isAllowanceCollapsed;
  }
  fromBx() {
    this.isFromBxCollapsed = !this.isFromBxCollapsed;
  }
  approve() {
    this.isApproveCollapsed = !this.isApproveCollapsed;
  }
  burnFrom() {
    this.isBurnFromCollapsed = !this.isBurnFromCollapsed;
  }
  transferFrom() {
    this.istransferFromCollapsed = !this.istransferFromCollapsed;
  }
  decreaseAllowance() {
    this.isDecreaseAllowanceCollapsed = !this.isDecreaseAllowanceCollapsed;
  }
  increaseAllowance() {
    this.isIncreaseAllowanceCollapsed = !this.isIncreaseAllowanceCollapsed;
  }
  updateLiquidityFeeToSell() {
    this.isupdateLiquidityFeeToSellCollapsed =
      !this.isupdateLiquidityFeeToSellCollapsed;
  }
  updateCharityAddress() {
    this.isupdateCharityAddressCollapsed =
      !this.isupdateCharityAddressCollapsed;
  }
  mint() {
    this.isMintCollapsed = !this.isMintCollapsed;
  }
  renounceOwnership() {
    this.isRenounceOwnershipCollapsed = !this.isRenounceOwnershipCollapsed;
  }
  transferOwnership() {
    this.isTransferOwnershipCollapsed = !this.isTransferOwnershipCollapsed;
  }
  withdrawNativeFromContract() {
    this.iswithdrawNativeFromContractCollapsed =
      !this.iswithdrawNativeFromContractCollapsed;
  }
  charityAddress() {
    this.ischarityAddressCollapsed = !this.ischarityAddressCollapsed;
  }
  charityFee() {
    this.ischarityFeeCollapsed = !this.ischarityFeeCollapsed;
  }
  charityFeeBalance() {
    this.ischarityFeeBalanceCollapsed = !this.ischarityFeeBalanceCollapsed;
  }
  charityFeeToSell() {
    this.ischarityFeeToSellCollapsed = !this.ischarityFeeToSellCollapsed;
  }
  enableFee() {
    this.isenableFeeCollapsed = !this.isenableFeeCollapsed;
  }
  enableMaxTransactionAmount() {
    this.isenableMaxTransactionAmountCollapsed =
      !this.isenableMaxTransactionAmountCollapsed;
  }
  getRoleAdmin() {
    this.isgetRoleAdminCollapsed = !this.isgetRoleAdminCollapsed;
  }
  updateMarketingFeeToSell() {
    this.isupdateMarketingFeeToSellCollapsed =
      !this.isupdateMarketingFeeToSellCollapsed;
  }
  isExcludedFromReward() {
    this.isExcludedFromRewardCollapsed = !this.isExcludedFromRewardCollapsed;
  }
  hasRole() {
    this.ishasRoleCollapsed = !this.ishasRoleCollapsed;
  }
  isExcludedFromDexFee() {
    this.isExcludedFromDexFeeCollapsed = !this.isExcludedFromDexFeeCollapsed;
  }
  liquidityFee() {
    this.isliquidityFeeCollapsed = !this.isliquidityFeeCollapsed;
  }
  updateMarketingFee() {
    this.isupdateMarketingFeeCollapsed = !this.isupdateMarketingFeeCollapsed;
  }
  liquidityFeeBalance() {
    this.isliquidityFeeBalanceCollapsed = !this.isliquidityFeeBalanceCollapsed;
  }
  liquidityFeeToSell() {
    this.isliquidityFeeToSellCollapsed = !this.isliquidityFeeToSellCollapsed;
  }
  updateMarketingAddress() {
    this.isupdateMarketingAddressCollapsed =
      !this.isupdateMarketingAddressCollapsed;
  }
  marketingAddress() {
    this.ismarketingAddressCollapsed = !this.ismarketingAddressCollapsed;
  }
  marketingFee() {
    this.ismarketingFeeCollapsed = !this.ismarketingFeeCollapsed;
  }
  marketingFeeBalance() {
    this.ismarketingFeeBalanceCollapsed = !this.ismarketingFeeBalanceCollapsed;
  }
  marketingFeeToSell() {
    this.ismarketingFeeToSellCollapsed = !this.ismarketingFeeToSellCollapsed;
  }
  reflectionFee() {
    this.isreflectionFeeCollapsed = !this.isreflectionFeeCollapsed;
  }
  supportInterface() {
    this.issupportInterfaceCollapsed = !this.issupportInterfaceCollapsed;
  }
  swapAndLiquifyEnabled() {
    this.isswapAndLiquifyEnabledCollapsed =
      !this.isswapAndLiquifyEnabledCollapsed;
  }
  tokenFromReflection() {
    this.istokenFromReflectionCollapsed = !this.istokenFromReflectionCollapsed;
  }
  transactionLimit() {
    this.istransactionLimitCollapsed = !this.istransactionLimitCollapsed;
  }
  updateReflectionFee() {
    this.isupdateReflectionFeeCollapsed = !this.isupdateReflectionFeeCollapsed;
  }
  uniswapV2Pair() {
    this.isuniswapV2PairCollapsed = !this.isuniswapV2PairCollapsed;
  }
  uniswapV2Router() {
    this.isuniswapV2RouterCollapsed = !this.isuniswapV2RouterCollapsed;
  }
  excludeFromDexFee() {
    this.isexcludeFromDexFeeCollapsed = !this.isexcludeFromDexFeeCollapsed;
  }
  excludeFromReward() {
    this.isexcludeFromDexRewardAddressCollapsed =
      !this.isexcludeFromDexRewardAddressCollapsed;
  }
  grantRole() {
    this.isgrantRoleCollapsed = !this.isgrantRoleCollapsed;
  }
  includeInDexFee() {
    this.isincludeInDexFeeCollapsed = !this.isincludeInDexFeeCollapsed;
  }
  includeInDexReward() {
    this.isincludeInDexRewardCollapsed = !this.isincludeInDexRewardCollapsed;
  }
  revokeRole() {
    this.isrevokeRoleCollapsed = !this.isrevokeRoleCollapsed;
  }
  updateCharityFeeToSell() {
    this.isupdateCharityFeeToSellCollapsed =
      !this.isupdateCharityFeeToSellCollapsed;
  }
  setValues() {
    this.issetValuesCollapsed = !this.issetValuesCollapsed;
  }
  updateSwapAndLiquifyEnabled() {
    this.isupdateSwapAndLiquifyEnabledCollapsed =
      !this.isupdateSwapAndLiquifyEnabledCollapsed;
  }

  unpause() {
    this.isUnpauseCollapsed = !this.isUnpauseCollapsed;
  }
  updateCharityFee() {
    this.isupdateCharityFeeCollapsed = !this.isupdateCharityFeeCollapsed;
  }
  totalFees() {
    this.istotalFeesCollapsed = !this.istotalFeesCollapsed;
  }
  renounceRole() {
    this.isrenounceRoleCollapsed = !this.isrenounceRoleCollapsed;
  }
  updateEnableMaxTransactionAmount() {
    this.isupdateEnableMaxTransactionAmountCollapsed =
      !this.isupdateEnableMaxTransactionAmountCollapsed;
  }
  updateLiquidityFee() {
    this.isupdateLiquidityFeeCollapsed = !this.isupdateLiquidityFeeCollapsed;
  }
  updateTransactionLimit() {
    this.isupdateTransactionLimitCollapsed =
      !this.isupdateTransactionLimitCollapsed;
  }

  pause() {
    this.isPauseCollapsed = !this.isPauseCollapsed;
  }
  transfer() {
    this.istransferCollapsed = !this.istransferCollapsed;
  }
  DEFAULT_ADMIN_ROLE() {
    this.isDEFAULT_ADMIN_ROLECollapsed = !this.isDEFAULT_ADMIN_ROLECollapsed;
  }
  LIQUIDITY_GENERATOR_ROLE() {
    this.isLIQUIDITY_GENERATOR_ROLECollapsed =
      !this.isLIQUIDITY_GENERATOR_ROLECollapsed;
  }
  updateEnableFee() {
    this.isupdateEnableFeeCollapsed = !this.isupdateEnableFeeCollapsed;
  }
  withdrawBEP20Token() {
    this.iswithdrawBEP20TokenCollapsed = !this.iswithdrawBEP20TokenCollapsed;
  }

  setActiveMenu(index: number) {
    this.isMenuActive = index;

    console.log('index', index);
  }

  public async onImportTokenAddress() {
    
    this.searchButton = 'Loading . . .';
    try {
      if (!this.tokenAddress) {
        this.isValidToken = 1;
      } else {
        const tokenDetails = await this.mytokenService.getTokenDetails(
          this.account.walletAddress,
          this.tokenAddress
        );
        console.log(tokenDetails);
        let owner = await this.commonContractService.toCheckSumAddress(
          this.account.walletAddress
        );
        if (
          tokenDetails.isfromBX == 'BX-Standard' ||
          tokenDetails.isfromBX == 'BX-Liquidity'
        ) {
          if (tokenDetails.owner == owner) {
            this.tokenInfo = await tokenDetails;
            this.isValidToken = 2;
            if (tokenDetails.isfromBX == 'BX-Standard') {
              this.tokenInfo.type = 'STANDARD_TOKEN';
            } else if (tokenDetails.isfromBX == 'BX-Liquidity') {
              this.tokenInfo.type = 'LIQUIDITY_TOKEN';
            }
            await this.mytokenService.setTokenAddressAndType(
              this.tokenAddress,
              this.tokenInfo.type
            );
            if (tokenDetails.isfromBX == 'BX-Standard') {
              let tokenInfo =
                await this.mytokenService.getStandardTokenReadFunctionsDetails(
                  this.tokenInfo.type
                );
              this.tokenInfo = tokenInfo;
            } else if (tokenDetails.isfromBX == 'BX-Liquidity') {
              let tokenInfo =
                await this.mytokenService.getLiquidityTokenReadFunctionsDetails(
                  this.tokenInfo.type
                );
              this.tokenInfo = tokenInfo;
            }
          } else {
            this.toastr.error('You are not an owner');
          }
        } else {
          this.toastr.error(
            'Please enter address i.e created from bx platform'
          );
        }
      }
    } catch (error) {
      this.tokenInfo = null;
      this.isValidToken = 3;
    }
    this.searchButton = 'Search';
  }

  async chooseContractType(value: any) {
    console.log(value);
  }

  /**
   * =======================================================
   * @dev Begining of Standard Contract Read Functions
   * =======================================================
   */

  /**
   * @param allowanceOwner
   * @param allowanceSpendor
   */
  async getAllowance(allowanceOwner: any, allowanceSpendor: any) {
    try {
      this.tokenInfo.allowance = await this.mytokenService.getAllowance(
        allowanceOwner,
        allowanceSpendor
      );
    } catch (err) {
      this.tokenInfo.allowance = err;
      console.log(err);
    }
  }

  /**
   *
   * @param account
   */
  async getBalanceOf(account: any) {
    try {
      this.tokenInfo.balance = await this.mytokenService.getBalanceOf(account);
    } catch (err) {
      this.tokenInfo.balance = err;
    }
  }

  /**
   *
   * @param byte
   */
  async readGetRoleAdmin(byte: any) {
    try {
      this.tokenInfo.getRoleAdmin = await this.mytokenService.getRoleAdmin(
        byte
      );
    } catch (err) {
      this.tokenInfo.getRoleAdmin = err;
    }
  }

  /**
   *
   * @param byte
   * @param address
   */
  async readHasRole(byte: any, address: any) {
    try {
      this.tokenInfo.hasRole = await this.mytokenService.getHasRole(
        byte,
        address
      );
    } catch (err) {}
  }

  /**
   *
   * @param address
   */
  async readIsExcludedFromDexFee(address: any) {
    try {
      this.tokenInfo.isExcludedFromDexFee =
        await this.mytokenService.getIsExcludedFromDexFee(address);
    } catch (err) {
      this.tokenInfo.isExcludedFromDexFee = err;
    }
  }

  /**
   *
   * @param address
   */
  async readisExcludedFromReward(address: any) {
    try {
      this.tokenInfo.isExcludedFromReward =
        await this.mytokenService.getIsExcludedFromReward(address);
    } catch (err) {
      this.tokenInfo.isExcludedFromReward = err;
    }
  }

  async readSupportInterface(supportInterfaceId: any) {
    try {
      this.tokenInfo.supportInterface =
        await this.mytokenService.getSupportInterface(supportInterfaceId);
    } catch (err) {
      this.tokenInfo.supportInterface = err;
    }
  }

  async readtokenFromReflection(tokenFromReflectionAmount: any) {
    try {
      this.tokenInfo.tokenFromReflection =
        await this.mytokenService.getTokenFromReflection(
          tokenFromReflectionAmount
        );
    } catch (err) {
      this.tokenInfo.tokenFromReflection = err;
    }
  }

  /**
   * =======================================================
   * @dev End of Standard Contract Read Functions
   * =======================================================
   */

  /**
   * =======================================================
   * @dev Begining of Standard Contract Write Functions
   * =======================================================
   */

  /**
   * @param spender
   * @param tokenAmount
   */
  async writeApprove(spender: any, tokenAmount: any) {
    this.initTransaction();
    try {
      const approveAbi = await this.mytokenService.approveAbi(
        spender,
        tokenAmount
      );
      const approve = await this.mytokenService.callTransactionWithAbi(
        this.account.walletAddress,
        this.tokenAddress,
        approveAbi
      );
      if (approve) {
        this.setTxnHash(approve);
      }
    } catch (error: any) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param burnAmount
   */
  async writeBurn(burnAmount: any) {
    this.initTransaction();
    try {
      const burnAbi = await this.mytokenService.burnAbi(burnAmount);
      const burn = await this.mytokenService.callTransactionWithAbi(
        this.account.walletAddress,
        this.tokenAddress,
        burnAbi
      );
      if (burn) {
        this.setTxnHash(burn);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param burnFromaccount
   * @param accountBurnAmount
   */
  async writeBunFrom(burnFromaccount: any, accountBurnAmount: any) {
    this.initTransaction();
    try {
      const burnFromAbi = await this.mytokenService.burnFromAbi(
        burnFromaccount,
        accountBurnAmount
      );
      const burnFrom = await this.mytokenService.callTransactionWithAbi(
        this.account.walletAddress,
        this.tokenAddress,
        burnFromAbi
      );
      if (burnFrom) {
        this.setTxnHash(burnFrom);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param decreaseAllowanceSpender
   * @param decreaseAllowanceAmount
   */
  async writeDecreaseAllowance(
    decreaseAllowanceSpender: any,
    decreaseAllowanceAmount: any
  ) {
    this.initTransaction();
    try {
      const decreaseAllowanceAbi =
        await this.mytokenService.decreaseAllowanceAbi(
          decreaseAllowanceSpender,
          decreaseAllowanceAmount
        );
      const decreaseAllowance =
        await this.mytokenService.callTransactionWithAbi(
          this.account.walletAddress,
          this.tokenAddress,
          decreaseAllowanceAbi
        );
      if (decreaseAllowance) {
        this.setTxnHash(decreaseAllowance);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param increaseAllowanceSpender
   * @param increaseAllowanceAmount
   */
  async writeIncreaseAllowance(
    increaseAllowanceSpender: any,
    increaseAllowanceAmount: any
  ) {
    this.initTransaction();
    try {
      const increaseAllowanceAbi =
        await this.mytokenService.increaseAllowanceAbi(
          increaseAllowanceSpender,
          increaseAllowanceAmount
        );
      const increaseAllowance =
        await this.mytokenService.callTransactionWithAbi(
          this.account.walletAddress,
          this.tokenAddress,
          increaseAllowanceAbi
        );
      if (increaseAllowance) {
        this.setTxnHash(increaseAllowance);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param mintAmount
   */
  async writeMint(mintAmount: any) {
    this.initTransaction();
    try {
      const mintAbi = await this.mytokenService.mintAbi(mintAmount);
      const mint = await this.mytokenService.callTransactionWithAbi(
        this.account.walletAddress,
        this.tokenAddress,
        mintAbi
      );
      if (mint) {
        this.setTxnHash(mint);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   * owner can pause the contract
   */
  async writePause() {
    this.initTransaction();
    try {
      const pauseAbi = await this.mytokenService.pauseAbi();
      const pause = await this.mytokenService.callTransactionWithAbi(
        this.account.walletAddress,
        this.tokenAddress,
        pauseAbi
      );
      if (pause) {
        this.setTxnHash(pause);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   * Transfering ownership to zeroAddress
   */
  async writeRenounceOwnership() {
    this.initTransaction();
    try {
      const renounceOwnershipAbi =
        await this.mytokenService.renounceOwnershipAbi();
      const renounceOwnership =
        await this.mytokenService.callTransactionWithAbi(
          this.account.walletAddress,
          this.tokenAddress,
          renounceOwnershipAbi
        );
      if (renounceOwnership) {
        this.setTxnHash(renounceOwnershipAbi);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param transferToAddress
   * @param transferToAmount
   */
  async writeTransfer(transferToAddress: any, transferToAmount: any) {
    this.initTransaction();
    try {
      const transferAbi = await this.mytokenService.transferAbi(
        transferToAddress,
        transferToAmount
      );
      const transfer = await this.mytokenService.callTransactionWithAbi(
        this.account.walletAddress,
        this.tokenAddress,
        transferAbi
      );
      if (transfer) {
        this.setTxnHash(transfer);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param transferFromFromAddress
   * @param transferFromToAddress
   * @param transferFromAmount
   */
  async writeTransferFrom(
    transferFromFromAddress: any,
    transferFromToAddress: any,
    transferFromAmount: any
  ) {
    this.initTransaction();
    try {
      const transferFromAbi = await this.mytokenService.transferFromAbi(
        transferFromFromAddress,
        transferFromToAddress,
        transferFromAmount
      );
      const transferFrom = await this.mytokenService.callTransactionWithAbi(
        this.account.walletAddress,
        this.tokenAddress,
        transferFromAbi
      );
      if (transferFrom) {
        this.setTxnHash(transferFrom);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param transferOwnershipAddress
   */
  async writeTransferOwnership(transferOwnershipAddress: any) {
    this.initTransaction();
    try {
      const transferOwnershipAbi =
        await this.mytokenService.transferOwnershipAbi(
          transferOwnershipAddress
        );
      const transferOwnership =
        await this.mytokenService.callTransactionWithAbi(
          this.account.walletAddress,
          this.tokenAddress,
          transferOwnershipAbi
        );
      if (transferOwnership) {
        this.setTxnHash(transferOwnership);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   * owner can unPause the contract
   */
  async writeUnPause() {
    this.initTransaction();
    try {
      const unpauseAbi = await this.mytokenService.unpauseAbi();
      const unpause = await this.mytokenService.callTransactionWithAbi(
        this.account.walletAddress,
        this.tokenAddress,
        unpauseAbi
      );
      if (unpause) {
        this.setTxnHash(unpause);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param excludeFromDexFeeAddress
   */
  async writeExcludeFromDexFee(excludeFromDexFeeAddress: any) {
    this.initTransaction();
    try {
      const excludeFromDexFeeAbi =
        await this.mytokenService.excludeFromDexFeeAbi(
          excludeFromDexFeeAddress
        );
      const excludeFromDexFee =
        await this.mytokenService.callTransactionWithAbi(
          this.account.walletAddress,
          this.tokenAddress,
          excludeFromDexFeeAbi
        );
      if (excludeFromDexFee) {
        this.setTxnHash(excludeFromDexFee);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param excludeFromDexRewardAddress
   */
  async writeExcludeFromReward(excludeFromDexRewardAddress: any) {
    this.initTransaction();
    try {
      const excludeFromRewardAbi =
        await this.mytokenService.excludeFromRewardAbi(
          excludeFromDexRewardAddress
        );
      const excludeFromReward =
        await this.mytokenService.callTransactionWithAbi(
          this.account.walletAddress,
          this.tokenAddress,
          excludeFromRewardAbi
        );
      if (excludeFromReward) {
        this.setTxnHash(excludeFromReward);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param grantRoleByte
   * @param grantRoleAddress
   */
  async writeGrantRole(grantRoleByte: any, grantRoleAddress: any) {
    this.initTransaction();
    try {
      const grantRoleAbi = await this.mytokenService.grantRoleAbi(
        grantRoleByte,
        grantRoleAddress
      );
      const grantRole = await this.mytokenService.callTransactionWithAbi(
        this.account.walletAddress,
        this.tokenAddress,
        grantRoleAbi
      );
      if (grantRole) {
        this.setTxnHash(grantRole);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param includeInDexFeeAddress
   */
  async writeIncludeInDexFee(includeInDexFeeAddress: any) {
    this.initTransaction();
    try {
      const includeInDexFeeAbi = await this.mytokenService.includeInDexFeeAbi(
        includeInDexFeeAddress
      );
      const includeInDexFee = await this.mytokenService.callTransactionWithAbi(
        this.account.walletAddress,
        this.tokenAddress,
        includeInDexFeeAbi
      );
      if (includeInDexFee) {
        this.setTxnHash(includeInDexFee);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param includeInDexRewardAddress
   */
  async writeIncludeInDexReward(includeInDexRewardAddress: any) {
    this.initTransaction();
    try {
      const includeInRewardAbi = await this.mytokenService.includeInRewardAbi(
        includeInDexRewardAddress
      );
      const includeInReward = await this.mytokenService.callTransactionWithAbi(
        this.account.walletAddress,
        this.tokenAddress,
        includeInRewardAbi
      );
      if (includeInReward) {
        this.setTxnHash(includeInReward);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   * owner can pause the contract
   */
  async writePauseContract() {
    this.initTransaction();
    try {
      const pauseContractAbi = await this.mytokenService.pauseContractAbi();
      const pause = await this.mytokenService.callTransactionWithAbi(
        this.account.walletAddress,
        this.tokenAddress,
        pauseContractAbi
      );
      if (pause) {
        this.setTxnHash(pause);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param renounceRoleByte
   * @param renounceRoleAddress
   */
  async writeRenounceRole(renounceRoleByte: any, renounceRoleAddress: any) {
    this.initTransaction();
    try {
      const renounceRoleAbi = await this.mytokenService.renounceRoleAbi(
        renounceRoleByte,
        renounceRoleAddress
      );
      const renounceRole = await this.mytokenService.callTransactionWithAbi(
        this.account.walletAddress,
        this.tokenAddress,
        renounceRoleAbi
      );
      if (renounceRole) {
        this.setTxnHash(renounceRole);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param revokeRoleByte
   * @param revokeRoleAddress
   */
  async writeRevokeRole(revokeRoleByte: any, revokeRoleAddress: any) {
    this.initTransaction();
    try {
      const revokeRoleAbi = await this.mytokenService.revokeRoleAbi(
        revokeRoleByte,
        revokeRoleAddress
      );
      const revokeRole = await this.mytokenService.callTransactionWithAbi(
        this.account.walletAddress,
        this.tokenAddress,
        revokeRoleAbi
      );
      if (revokeRole) {
        this.setTxnHash(revokeRole);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param setValue_refectionFee
   * @param setValue_liquidityFee
   * @param setValue_liquidityFeeToSell
   * @param setValue_marketingFee
   * @param setValue_marketingFeeToSell
   * @param setValue_marketingAddress
   * @param setValue_charityFee
   * @param setValue_charityFeeToSell
   * @param setValue_charityAddress
   * @param setValue_trasactionLimit
   */
  async writeSetValues(
    setValue_refectionFee: any,
    setValue_liquidityFee: any,
    setValue_liquidityFeeToSell: any,
    setValue_marketingFee: any,
    setValue_marketingFeeToSell: any,
    setValue_marketingAddress: any,
    setValue_charityFee: any,
    setValue_charityFeeToSell: any,
    setValue_charityAddress: any,
    setValue_trasactionLimit: any
  ) {
    this.initTransaction();
    try {
      const setValuesAbi = await this.mytokenService.setValuesAbi(
        setValue_refectionFee,
        setValue_liquidityFee,
        setValue_liquidityFeeToSell,
        setValue_marketingFee,
        setValue_marketingFeeToSell,
        setValue_marketingAddress,
        setValue_charityFee,
        setValue_charityFeeToSell,
        setValue_charityAddress,
        setValue_trasactionLimit
      );
      const setValues = await this.mytokenService.callTransactionWithAbi(
        this.account.walletAddress,
        this.tokenAddress,
        setValuesAbi
      );
      if (setValues) {
        this.setTxnHash(setValues);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   * can unpause the contract if paused
   */
  async writeUnPauseContract() {
    this.initTransaction();
    try {
      const unpauseContractAbi = await this.mytokenService.unpauseContractAbi();
      const unPauseContract = await this.mytokenService.callTransactionWithAbi(
        this.account.walletAddress,
        this.tokenAddress,
        unpauseContractAbi
      );
      if (unPauseContract) {
        this.setTxnHash(unPauseContract);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param updateCharityAddressAddress
   */
  async writeUpdateCharityAddress(updateCharityAddressAddress: any) {
    this.initTransaction();
    try {
      const updateCharityAddressAbi =
        await this.mytokenService.updateCharityAddressAbi(
          updateCharityAddressAddress
        );
      const updateCharityAddress =
        await this.mytokenService.callTransactionWithAbi(
          this.account.walletAddress,
          this.tokenAddress,
          updateCharityAddressAbi
        );
      if (updateCharityAddress) {
        this.setTxnHash(updateCharityAddress);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param updateCharityFeeAount
   */
  async writeUpdateCharityFee(updateCharityFeeAount: any) {
    this.initTransaction();
    try {
      const updateCharityFeeAbi = await this.mytokenService.updateCharityFeeAbi(
        updateCharityFeeAount
      );
      const updateCharityFee = await this.mytokenService.callTransactionWithAbi(
        this.account.walletAddress,
        this.tokenAddress,
        updateCharityFeeAbi
      );
      if (updateCharityFee) {
        this.setTxnHash(updateCharityFee);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param updateCharityFeeToSellAmountAmount
   */
  async writeUpdateCharityFeeToSellAmount(
    updateCharityFeeToSellAmountAmount: any
  ) {
    this.initTransaction();
    try {
      const updateCharityFeeToSellAbi =
        await this.mytokenService.updateCharityFeeAbi(
          updateCharityFeeToSellAmountAmount
        );
      const updateCharityFeeToSell =
        await this.mytokenService.callTransactionWithAbi(
          this.account.walletAddress,
          this.tokenAddress,
          updateCharityFeeToSellAbi
        );
      if (updateCharityFeeToSell) {
        this.setTxnHash(updateCharityFeeToSell);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param updateEnableFeeBool
   */
  async writeUpdateEnableFee(updateEnableFeeBool: any) {
    this.initTransaction();
    try {
      const updateEnableFeeAbi = await this.mytokenService.updateEnableFeeAbi(
        updateEnableFeeBool
      );
      const updateEnableFee = await this.mytokenService.callTransactionWithAbi(
        this.account.walletAddress,
        this.tokenAddress,
        updateEnableFeeAbi
      );
      if (updateEnableFee) {
        this.setTxnHash(updateEnableFee);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param updateEnableMaxTransactionAmountBool
   */
  async writeUpdateEnableMaxTransactionAmount(
    updateEnableMaxTransactionAmountBool: any
  ) {
    this.initTransaction();
    try {
      const updateEnableMaxTransactionAmountAbi =
        await this.mytokenService.updateEnableMaxTransactionAmountAbi(
          updateEnableMaxTransactionAmountBool
        );
      const updateEnableMaxTransactionAmount =
        await this.mytokenService.callTransactionWithAbi(
          this.account.walletAddress,
          this.tokenAddress,
          updateEnableMaxTransactionAmountAbi
        );
      if (updateEnableMaxTransactionAmount) {
        this.setTxnHash(updateEnableMaxTransactionAmount);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param updateLiquidityFeeAmount
   */
  async writeUpdateLiquidityFee(updateLiquidityFeeAmount: any) {
    this.initTransaction();
    try {
      const updateLiquidityFeeAbi =
        await this.mytokenService.updateLiquidityFeeAbi(
          updateLiquidityFeeAmount
        );
      const updateLiquidityFee =
        await this.mytokenService.callTransactionWithAbi(
          this.account.walletAddress,
          this.tokenAddress,
          updateLiquidityFeeAbi
        );
      if (updateLiquidityFee) {
        this.setTxnHash(updateLiquidityFee);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param updateLiquidityFeeToSellAmount
   */
  async writeUpdateLiquidityFeeToSell(updateLiquidityFeeToSellAmount: any) {
    this.initTransaction();
    try {
      const updateLiquidityFeeToSellAbi =
        await this.mytokenService.updateLiquidityFeeToSellAbi(
          updateLiquidityFeeToSellAmount
        );
      const updateLiquidityFeeToSell =
        await this.mytokenService.callTransactionWithAbi(
          this.account.walletAddress,
          this.tokenAddress,
          updateLiquidityFeeToSellAbi
        );
      if (updateLiquidityFeeToSell) {
        this.setTxnHash(updateLiquidityFeeToSell);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param updateMarketingAddressAddress
   */
  async writeUpdateMarketingAddress(updateMarketingAddressAddress: any) {
    this.initTransaction();
    try {
      const updateMarketingAddressAbi =
        await this.mytokenService.updateMarketingAddressAbi(
          updateMarketingAddressAddress
        );
      const updateMarketingAddress =
        await this.mytokenService.callTransactionWithAbi(
          this.account.walletAddress,
          this.tokenAddress,
          updateMarketingAddressAbi
        );
      if (updateMarketingAddress) {
        this.setTxnHash(updateMarketingAddress);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param updateMarketingFeeAmount
   */
  async writeUpdateMarketingFee(updateMarketingFeeAmount: any) {
    this.initTransaction();
    try {
      const updateMarketingFeeAbi =
        await this.mytokenService.updateMarketingFeeAbi(
          updateMarketingFeeAmount
        );
      const updateMarketingFee =
        await this.mytokenService.callTransactionWithAbi(
          this.account.walletAddress,
          this.tokenAddress,
          updateMarketingFeeAbi
        );
      if (updateMarketingFee) {
        this.setTxnHash(updateMarketingFee);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param updateMarketingFeeToSellAmount
   */
  async writeUpdateMarketingFeeToSell(updateMarketingFeeToSellAmount: any) {
    this.initTransaction();
    try {
      const updateMarketingFeeToSellAbi =
        await this.mytokenService.updateMarketingFeeToSellAbi(
          updateMarketingFeeToSellAmount
        );
      const updateMarketingFeeToSell =
        await this.mytokenService.callTransactionWithAbi(
          this.account.walletAddress,
          this.tokenAddress,
          updateMarketingFeeToSellAbi
        );
      if (updateMarketingFeeToSell) {
        this.setTxnHash(updateMarketingFeeToSell);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param updateReflectionFeeAmount
   */
  async writeUpdateReflectionFee(updateReflectionFeeAmount: any) {
    this.initTransaction();
    try {
      const updateReflectionFeeAbi =
        await this.mytokenService.updateReflectionFeeAbi(
          updateReflectionFeeAmount
        );
      const updateReflectionFee =
        await this.mytokenService.callTransactionWithAbi(
          this.account.walletAddress,
          this.tokenAddress,
          updateReflectionFeeAbi
        );
      if (updateReflectionFee) {
        this.setTxnHash(updateReflectionFee);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param updateSwapAndLiquifyEnabledBool
   */
  async writeUpdateSwapAndLiquifyEnabled(updateSwapAndLiquifyEnabledBool: any) {
    this.initTransaction();
    try {
      const updateSwapAndLiquifyEnabledAbi =
        await this.mytokenService.updateSwapAndLiquifyEnabledAbi(
          updateSwapAndLiquifyEnabledBool
        );
      const updateSwapAndLiquifyEnabled =
        await this.mytokenService.callTransactionWithAbi(
          this.account.walletAddress,
          this.tokenAddress,
          updateSwapAndLiquifyEnabledAbi
        );
      if (updateSwapAndLiquifyEnabled) {
        this.setTxnHash(updateSwapAndLiquifyEnabled);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param updateTransactionLimitAmount
   */
  async writeUpdateTransactionLimit(updateTransactionLimitAmount: any) {
    this.initTransaction();
    try {
      const updateTransactionLimitAbi =
        await this.mytokenService.updateTransactionLimitAbi(
          updateTransactionLimitAmount
        );
      const updateTransactionLimit =
        await this.mytokenService.callTransactionWithAbi(
          this.account.walletAddress,
          this.tokenAddress,
          updateTransactionLimitAbi
        );
      if (updateTransactionLimit) {
        this.setTxnHash(updateTransactionLimit);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param withdrawBEP20TokenAddress
   * @param withdrawBEP20TokenAmount
   */
  async writeWithdrawBEP20Token(
    withdrawBEP20TokenAddress: any,
    withdrawBEP20TokenAmount: any
  ) {
    this.initTransaction();
    try {
      const withdrawBEP20TokenAbi =
        await this.mytokenService.withdrawBEP20TokenAbi(
          withdrawBEP20TokenAddress,
          withdrawBEP20TokenAmount
        );
      const withdrawBEP20Token =
        await this.mytokenService.callTransactionWithAbi(
          this.account.walletAddress,
          this.tokenAddress,
          withdrawBEP20TokenAbi
        );
      if (withdrawBEP20Token) {
        this.setTxnHash(withdrawBEP20Token);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   *
   * @param withdrawNativeAddress
   * @param withdrawNativeAmount
   */
  async writeWithdrawNativeFromContract(
    withdrawNativeAddress: any,
    withdrawNativeAmount: any
  ) {
    this.initTransaction();
    try {
      const withdrawBnbFromContractAbi =
        await this.mytokenService.withdrawBnbFromContractAbi(
          withdrawNativeAddress,
          withdrawNativeAmount
        );
      const withdrawBnbFromContract =
        await this.mytokenService.callTransactionWithAbi(
          this.account.walletAddress,
          this.tokenAddress,
          withdrawBnbFromContractAbi
        );
      if (withdrawBnbFromContract) {
        this.setTxnHash(withdrawBnbFromContract);
      }
    } catch (error) {
      this.errorCatch(error);
    }
  }

  /**
   * =======================================================
   * @dev End of Standard Contract Write Functions
   * =======================================================
   */

  /**
   * =======================================================
   * @dev Begining of Common function for init transaction
   * =======================================================
   */

  /**
   * set transaction hash detials and message
   */
  async setTxnHash(token: any) {
    this.showViewTransaction[this.functionErrorIndex] = true;
    this.functionProcessing[this.functionErrorIndex] = 'Write';
    
    this.transactionHash = await token.data.transactionHash;
  }

  /**
   * open transaction explorer page in new tab
   */
  public openTXPage() {
    window.open(this.transactionUri + this.transactionHash, '_blank');
    console.log('uri', this.transactionUri);
  }

  /**
   * Close transaction modal
   */
  async closeTransactionModal() {
    this.modalProcessing = false;
  }

  /**
   * declaring state variable to show progress on ui
   */
  async initTransaction() {
    this.showViewTransaction[this.functionErrorIndex] = false;
  }

  connectWallet() {
    this.commonContractService.enableMetaMaskConnection(true);
  }

  /**
   *
   * @param error
   * declaring error message for transactions
   */
  async errorCatch(error: any) {
    console.log(error);
    this.functionProcessing[this.functionErrorIndex] = 'Write';
    this.functionError[this.functionErrorIndex] = error;
    if (error.data?.code === 4001) {
      this.toastr.error('User Rejected');
      this.functionError[this.functionErrorIndex] = 'User Rejected';
      this.showViewTransaction[this.functionErrorIndex] = false;
    } else if (error.data.receipt) {
      this.toastr.error('Transaction Failed');
      this.functionError[this.functionErrorIndex] = 'Transaction Failed';
      this.showViewTransaction[this.functionErrorIndex] = true;
      this.transactionHash = error.data.receipt.transactionHash;
    } else {
      this.showViewTransaction[this.functionErrorIndex] = false;
      this.toastr.error('Transaction Failed');
      this.functionError[this.functionErrorIndex] = 'Transaction Failed';
    }
  }

  /**
   * =======================================================
   * @dev End of Common function for init transaction
   * =======================================================
   */

  /**
   * open address details explorer page in new tab
   */
  public openAddressExplorer(address: any) {
    window.open(this.contractURI + address, '_blank');
  }

  public async setFunctionError(index: any) {
    this.functionError = [];
    this.showViewTransaction = [];
    this.functionProcessing = [];
    for (let i = 0; i < this.totalfunctionLength; i++) {
      this.functionError.push('');
      this.showViewTransaction.push(false);
      this.functionProcessing.push('Write');
    }
    this.functionErrorIndex = index;
    this.functionProcessing[index] = 'Processing . . .';
  }
}
